import { TextLink } from "../../../mdx-pages/components/content/link";
import { SectionTitle } from "../../../mdx-pages/components/typography";
import { ABOUT_US_PAGE } from "../../../providers/routing/routes";
import { getUrl } from "../../../shared/utils/getUrl";
import { content, privacyPolicyFooter } from "./styles.css";

type PrivacyPolicyFooterProps = {
  isGermany?: boolean;
};

const footerContent = {
  en: {
    title: "Contact Us",
    contactText:
      "If you have any questions about this Privacy Policy, You can contact Us:",
    emailText: "By email: info@all3.com",
    siteText: "By visiting this page on Our Website:",
    pageName: "about us",
    complaintText:
      "All enquiries or complaints will be taken seriously and will be handled as soon as reasonably practicable.",
    updateText: "Last updated: March 2025",
  },
  de: {
    title: "Kontaktieren Sie uns",
    contactText:
      "Bei Fragen zu dieser Datenschutzbestimmung können Sie uns kontaktieren:",
    emailText: "Per E-Mail: info@all3.com",
    siteText: "Besuchen Sie unsere Website:",
    pageName: "Über uns",
    complaintText:
      "Alle Anfragen und Beschwerden werden ernst genommen und schnellstmöglich bearbeitet.",
    updateText: "Stand: März 2025",
  },
};

export const PrivacyPolicyFooter = ({
  isGermany = false,
}: PrivacyPolicyFooterProps) => {
  const contentText = isGermany ? footerContent.de : footerContent.en;

  return (
    <div className={privacyPolicyFooter}>
      <div className={content}>
        <div>
          <SectionTitle>{contentText.title}</SectionTitle>

          <p>{contentText.contactText}</p>

          <p>{contentText.emailText}</p>

          <p>
            {contentText.siteText}{" "}
            <TextLink to={getUrl(isGermany ? "de" : "en", ABOUT_US_PAGE)}>
              {contentText.pageName}
            </TextLink>
          </p>

          <p>{contentText.complaintText}</p>
          <p>{contentText.updateText}</p>
        </div>
      </div>
    </div>
  );
};
